(function () {
  'use strict';

  /* ---------- shared state ---------- */
  var S = {
    plan: 'b2',               // 'b2' = 1 Month Free (3 pouches), 'b1' = 1 Month Supply
    mix: { original: 3, coffee: 0 },
    addon: false,
    shipNow: true              // vs pre-order
  };

  var blendHost = document.querySelector('[data-pdp-v2-blend]');
  var ownBlend = blendHost ? blendHost.getAttribute('data-pdp-v2-blend') : 'original';
  if (ownBlend === 'coffee') S.mix = { original: 0, coffee: 3 };

  function mixCount() { return S.mix.original + S.mix.coffee; }

  function restoreMixFromSession() {
    try {
      var saved = sessionStorage.getItem('pdpV2Mix');
      if (saved) {
        var parsed = JSON.parse(saved);
        sessionStorage.removeItem('pdpV2Mix');
        if (parsed && typeof parsed.original === 'number' && typeof parsed.coffee === 'number') {
          S.mix = parsed;
        }
      }
    } catch (e) {}
  }

  /* ---------- blend selector ---------- */
  function initBlend() {
    var wrap = document.querySelector('.pdp-v2-blend');
    if (!wrap) return;

    function label(mix) {
      if (mix.coffee === 0) return '3× Original';
      if (mix.original === 0) return '3× Coffee';
      return mix.original + ' Original + ' + mix.coffee + ' Coffee';
    }

    function effectiveBlend() {
      if (S.mix.coffee > S.mix.original) return 'coffee';
      return 'original';
    }

    function render() {
      wrap.classList.toggle('pdp-v2-b1', S.plan === 'b1');
      wrap.classList.toggle('pdp-v2-b2', S.plan === 'b2');

      var hd = wrap.querySelector('[data-pdp-v2="bldHd"]');
      if (hd) hd.textContent = S.plan === 'b2' ? 'Build your 3-pack' : 'Choose your blend';

      var rd = wrap.querySelector('[data-pdp-v2="bldRd"]');
      if (rd) rd.textContent = S.plan === 'b2' ? label(S.mix) : '';

      var oOut = wrap.querySelector('[data-pdp-v2="mixO"]');
      var cOut = wrap.querySelector('[data-pdp-v2="mixC"]');
      if (oOut) oOut.textContent = S.mix.original;
      if (cOut) cOut.textContent = S.mix.coffee;

      wrap.querySelectorAll('.pdp-v2-row').forEach(function (row) {
        var blend = row.getAttribute('data-blend');
        var checked = blend === effectiveBlend();
        row.setAttribute('aria-checked', checked);
      });

      document.dispatchEvent(new CustomEvent('pdp-v2:mix-changed', { detail: { mix: S.mix, plan: S.plan } }));
    }

    wrap.addEventListener('click', function (e) {
      var stepBtn = e.target.closest('[data-mix]');
      if (stepBtn) {
        var k = stepBtn.getAttribute('data-mix');
        var d = parseInt(stepBtn.getAttribute('data-d'), 10);
        var other = k === 'original' ? 'coffee' : 'original';
        if (d > 0) {
          if (S.mix[k] >= 3) return;
          S.mix[k]++;
          if (mixCount() > 3) S.mix[other]--;
        } else {
          if (S.mix[k] <= 0) return;
          S.mix[k]--;
          S.mix[other]++;
        }
        render();
        maybeSwitchProduct();
        return;
      }
      var row = e.target.closest('.pdp-v2-row');
      if (row && S.plan === 'b1') {
        var pick = row.getAttribute('data-blend');
        if (pick === effectiveBlend()) return;
        S.mix = pick === 'coffee' ? { original: 0, coffee: 3 } : { original: 3, coffee: 0 };
        render();
        maybeSwitchProduct();
      }
    });

    // re-render heading/rows whenever the plan card changes
    document.addEventListener('pdp-v2:plan-changed', render);

    // majority blend owns the page: if the majority tips away from this page's own product, navigate
    function maybeSwitchProduct() {
      var majority = effectiveBlend();
      if (majority === ownBlend) return;

      var target = majority === 'coffee'
        ? wrap.getAttribute('data-coffee-url')
        : wrap.getAttribute('data-original-url');
      if (!target) return;

      try { sessionStorage.setItem('pdpV2Mix', JSON.stringify(S.mix)); } catch (e) {}
      try { sessionStorage.setItem('pdpV2Plan', S.plan); } catch (e) {}
      try { sessionStorage.setItem('pdpV2ScrollY', window.scrollY); } catch (e) {}

      var url = new URL(target, window.location.origin);
      var currentParams = new URLSearchParams(window.location.search);
      ['view', 'pdp'].forEach(function (key) {
        if (currentParams.has(key)) url.searchParams.set(key, currentParams.get(key));
      });
      window.location.href = url.pathname + url.search;
    }

    restoreMixFromSession();
    render();

    var savedScroll = null;
    try { savedScroll = sessionStorage.getItem('pdpV2ScrollY'); } catch (e) {}
    if (savedScroll !== null) {
      try { sessionStorage.removeItem('pdpV2ScrollY'); } catch (e) {}
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          window.scrollTo({ top: parseInt(savedScroll, 10), behavior: 'instant' });
        });
      });
    }
  }

  /* ---------- plan cards ---------- */
  function initPlans() {
    var plans = document.querySelectorAll('.pdp-v2-plan');
    if (!plans.length) return;
    plans.forEach(function (p) {
      p.addEventListener('click', function (e) {
        if (e.target.closest('.pdp-v2-gin, .pdp-v2-tiles')) return; // clicks inside body don't reselect the card
        S.plan = p.getAttribute('data-plan');
        plans.forEach(function (x) { x.setAttribute('aria-checked', x === p); });
        document.dispatchEvent(new CustomEvent('pdp-v2:plan-changed', { detail: { plan: S.plan } }));
        var blendWrap = document.querySelector('.pdp-v2-blend');
        if (blendWrap) blendWrap.classList.toggle('pdp-v2-b1', S.plan === 'b1');
        if (blendWrap) blendWrap.classList.toggle('pdp-v2-b2', S.plan === 'b2');
      });
    });

    var savedPlan = null;
    try { savedPlan = sessionStorage.getItem('pdpV2Plan'); sessionStorage.removeItem('pdpV2Plan'); } catch (e) {}
    if (savedPlan === 'b1') {
      var b1 = document.querySelector('.pdp-v2-plan[data-plan="b1"]');
      if (b1) b1.click();
    }
  }

  /* ---------- add-on ---------- */
  function initAddon() {
    var btn = document.querySelector('[data-pdp-v2-bump]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      S.addon = !S.addon;
      btn.setAttribute('aria-checked', S.addon);
      document.dispatchEvent(new CustomEvent('pdp-v2:addon-changed', { detail: { addon: S.addon } }));
    });
  }

  /* ---------- ship now / pre-order toggle ---------- */
  function initShipToggle() {
    document.addEventListener('pdp-v2:ship-mode-changed', function (e) {
      S.shipNow = e.detail.shipNow;
    });
  }

  /* ---------- gifts strip / giftlink open the gifts popup ---------- */
  function initGiftOpeners() {
    document.querySelectorAll('[data-pdp-v2-open-gifts]').forEach(function (el) {
      el.addEventListener('click', function () {
        var modal = document.getElementById('PdpV2GiftsModal');
        if (modal && modal.show) modal.show(el);
      });
    });
  }

  /* ---------- sticky ATC ---------- */
  function initSticky() {
    var btns = document.querySelector('[data-pdp-v2-atc-anchor]');
    var bar = document.querySelector('.pdp-v2-satc');
    if (!btns || !bar || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      var r = entries[0];
      bar.classList.toggle('pdp-v2-show', !r.isIntersecting && r.boundingClientRect.top < 0);
    }).observe(btns);

    var backLink = bar.querySelector('[data-pdp-v2-back]');
    if (backLink) {
      backLink.addEventListener('click', function () {
        btns.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    var label = bar.querySelector('[data-pdp-v2-plan-label]');
    if (label) {
      document.addEventListener('pdp-v2:plan-changed', function (e) {
        label.textContent = e.detail.plan === 'b1' ? '1 Month Supply · 1 pouch' : '1 Month Free · 3 pouches';
      });
    }
  }


  /* ---------- cart-attribute (Phase 4) ---------- */
  function initCartAttribute() {
    var params = new URLSearchParams(window.location.search);
    var pdp = params.get('pdp');
    if (pdp !== 'a' && pdp !== 'b') return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.attributes && cart.attributes.pdp === pdp) return; // already correct, no request
        return fetch(window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { pdp: pdp } })
        });
      })
      .catch(function () {});
  }

  /* ---------- preserve view/pdp params on every internal PDP link ---------- */
  function preserveParamsOnLinks() {
    var params = new URLSearchParams(window.location.search);
    var keep = {};
    ['view', 'pdp'].forEach(function (k) { if (params.has(k)) keep[k] = params.get(k); });
    if (!Object.keys(keep).length) return;

    document.querySelectorAll('[data-pdp-v2-preserve-params]').forEach(function (a) {
      try {
        var url = new URL(a.href, window.location.origin);
        Object.keys(keep).forEach(function (k) { url.searchParams.set(k, keep[k]); });
        a.href = url.pathname + url.search;
      } catch (e) {}
    });
  }

  function initClaimsPlacement() {
    var claims = document.getElementById('PdpV2Claims');
    var firstSlide = document.querySelector('.product__media-list .product__media-item');
    if (!claims || !firstSlide) return;
    // sit on the photo box itself (not the wider slide) so the overlay matches the image edges and corners
    var host = firstSlide.querySelector('.product-media-container') || firstSlide;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.appendChild(claims);
    claims.hidden = false;
  }

  // mobile: icon tiles sit between description and blend selector; desktop: back beside the gallery
  function initIconTilesPlacement() {
    var tiles = document.querySelector('[data-pdp-v2-blend] .product-icon-with__text');
    var desc = document.querySelector('[data-pdp-v2-blend] .pdp-v2-desc.mobile');
    if (!tiles || !desc) return;
    var home = tiles.parentElement;
    var anchor = tiles.nextSibling;
    var mq = window.matchMedia('(max-width: 749px)');
    function place() {
      if (mq.matches) {
        desc.insertAdjacentElement('afterend', tiles);
        tiles.classList.add('pdp-v2-tiles-mobile');
      } else if (tiles.parentElement !== home) {
        home.insertBefore(tiles, anchor);
        tiles.classList.remove('pdp-v2-tiles-mobile');
      }
    }
    place();
    mq.addEventListener('change', place);
  }

  // card footer: fall back to the short line whenever the long one would not fit
  function initFooterFit() {
    function fit() {
      document.querySelectorAll('.pdp-v2-cardfoot').forEach(function (f) {
        var long = f.querySelector('.pdp-v2-cf-long');
        if (!f.offsetWidth || !long) return;
        f.classList.remove('pdp-v2-tight');
        if (long.scrollWidth > long.clientWidth + 1) f.classList.add('pdp-v2-tight');
      });
    }
    fit();
    window.addEventListener('resize', fit);
    document.addEventListener('pdp-v2:plan-changed', function () { requestAnimationFrame(fit); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFooterFit();
    initClaimsPlacement();
    initIconTilesPlacement();
    initBlend();
    initPlans();
    initAddon();
    initShipToggle();
    initGiftOpeners();
    initSticky();
    initCartAttribute();
    preserveParamsOnLinks();
  });
})();
